export default __webpack_public_path__ + "static/media/category_image.f7a965bc.svg";